
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderShippingDialog extends Serenity.EntityDialog<OrderShippingRow, any> {
        protected getFormKey() { return OrderShippingForm.formKey; }
        protected getIdProperty() { return OrderShippingRow.idProperty; }
        protected getLocalTextPrefix() { return OrderShippingRow.localTextPrefix; }
        protected getNameProperty() { return OrderShippingRow.nameProperty; }
        protected getService() { return OrderShippingService.baseUrl; }
        protected getDeletePermission() { return OrderShippingRow.deletePermission; }
        protected getInsertPermission() { return OrderShippingRow.insertPermission; }
        protected getUpdatePermission() { return OrderShippingRow.updatePermission; }

        protected form = new OrderShippingForm(this.idPrefix);
        constructor() {
            super();
            //this.form.OrdershippingBooks.vOrderId = parseInt(this.form.OrderId.value);
            //this.form.OrdershippingPendrives.vOrderId = parseInt(this.form.OrderId.value);

            this.form.EStatus.change(e => {

                var getStatus = this.form.EStatus.value;
                //debugger;
                if (this.isNew) {
                    if (getStatus == '1' || getStatus == "3") {

                        Orders.OrderShippingService.Retrieve2({
                            EntityId: this.form.OrderId.value
                        }, response => {
                            this.setProductDetails(response.Entity);

                        });
                    }
                }
            });
        }

        loadEntity(entity: OrderShippingRow) {
            super.loadEntity(entity);
            this.form.OrdershippingBooks.vOrderId = parseInt(this.form.OrderId.value);
            this.form.OrdershippingPendrives.vOrderId = parseInt(this.form.OrderId.value);
            if (this.isNew()) {
                if (this.form.OrderId != null) {
                    var vOrderId = this.form.OrderId.value;
                    try {
                        Orders.OrdersService.Retrieve({
                            EntityId: parseInt(vOrderId)
                        }, response => {
                            if (response.Entity.ShippingProviderId != null) {
                                this.form.ShippingProviderId.value = response.Entity.ShippingProviderId.toString();
                                this.form.EStatus.value = response.Entity.EShippingStatus.toString();
                            }
                            else {
                                Q.notifyError("Shipping Provider Not assigned");
                            }
                        });
                    }
                    catch (e) { }
                }
            }
            else {
                var getStatus = this.form.EStatus.value;
                if (getStatus == '4') {
                    Orders.OrderShippingService.Retrieve2({
                        EntityId: this.form.OrderId.value
                    }, response => {
                        this.setProductDetails(response.Entity);
                    });
                }
            }


            this.form.ShippingProviderId.change(e => {
                var vshippingProviderId = this.form.ShippingProviderId.value;

                if (Q.isEmptyOrNull(vshippingProviderId)) {
                    this.setShippingProviderDetails({});
                }
                else {
                    try {
                        Shipping.ShippingProvidersService.Retrieve({
                            EntityId: parseInt(vshippingProviderId)
                            //      
                        }, response => {
                            this.form.TrackingUrl.value = response.Entity.TrackingUrl;
                        });
                    } catch (e) {

                    }
                }                
            });

            /*var id = Q.first(Shipping.ShippingProvidersRow.getLookup().items, x => x.Id.toString() == this.form.ShippingProviderId.value).Id;

            Shipping.ShippingProvidersService.Retrieve({
                EntityId: id
            }, response => {
                this.setShippingProviderDetails(response.Entity);
            });*/
        }
/*
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.push({
                title: Q.text('Assign Tracking Number'),
                cssClass: 'Add-button',
                onClick: () => {
                    Q.serviceRequest('Orders/OrderShipping/AssignTrackingNumbers', {
                        EntityId: this.entityId,
                        Entity: this.entity
                    }, (response) => {
                        Q.notifySuccess("Tracking Number Updated Successfully");
                        this.element.find(".Add-button").toggle(false);
                    });
                }
            });
            return buttons;
        }

*/
        private setProductDetails(details: Orders.OrderShippingRow) {
            // this.form.OrdershippingBooks = details.;
            this.form.OrdershippingBooks.value = details.OrdershippingBooks;
            this.form.OrdershippingPendrives.value = details.OrdershippingPendrives;
        }

        private setShippingProviderDetails(details: Shipping.ShippingProvidersRow) {
            // this.form.OrdershippingBooks = details.;
            this.form.ShippingProviderId.value = details.Id.toString();
            this.form.TrackingUrl.value = details.TrackingUrl;
        }
    }
}